import { handleActions } from 'redux-actions'
import {
  firebaseSignin,
  firebaseSignout,
  signinSuccess,
  signinError,
  resetRedirectTo,
  signinStart
} from './actions'
import {
  ERROR_WRONG_PASSWORD,
  EMAIL_NOT_FOUND,
  ERROR_UNKNOWN
} from './constants'

const defaultState = {
  pending: true,
  user: null,
  error: null,
  redirectTo: null,
  keys: {}
}

export default handleActions(
  {
    [firebaseSignin]: (state, { payload: user }) => ({
      ...state,
      user,
      pending: false
    }),
    [firebaseSignout]: state => ({
      ...state,
      user: null,
      pending: false
    }),
    [signinStart]: state => ({ ...state, error: null, pending: true }),
    [signinSuccess]: state => ({ ...state, error: null, redirectTo: '/notes' }),
    [resetRedirectTo]: state => ({ ...state, redirectTo: null }),
    [signinError]: (state, { payload: err }) => {
      if (err.code === 'auth/wrong-password') {
        return { ...state, error: ERROR_WRONG_PASSWORD }
      } else if (err.code === 'auth/user-not-found') {
        return { ...state, error: EMAIL_NOT_FOUND }
      } else {
        return { ...state, error: ERROR_UNKNOWN }
      }
    }
  },
  defaultState
)



// WEBPACK FOOTER //
// ./src/services/signin/reducer.js